import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22main-theme.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./fonts/roboto-mono-latin-wght-normal.woff2%22,%22weight%22:%22100%20700%22,%22style%22:%22normal%22,%22display%22:%22swap%22,%22fallback%22:[%22monospace%22],%22variable%22:%22--font-roboto-mono%22}],%22variableName%22:%22robotoMono%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'robotoMono', 'robotoMono Fallback', monospace",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
